import React, { useEffect } from 'react';
import { CheckCircle, XCircle, Info } from 'lucide-react';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  duration?: number;
  onClose: () => void;
}

/* 旧 styled-components 定義。keyframes は globals.css へ移設（msc- 接頭辞）。
 * font-size は line-height が別指定なのでどちらも arbitrary value で保持する。 */
const TOAST_CONTAINER =
  'fixed top-6 right-6 z-[10001] flex items-center gap-3 px-5 py-3.5 rounded-tasky-sm ' +
  'shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] ' +
  'animate-[msc-toast-slide-in_0.3s_ease-out,msc-fade-out_0.3s_ease-in_2.7s] ' +
  'min-w-[300px] max-w-[min(500px,calc(100vw-3rem))] ' +
  /* 狭幅では左右 12px マージンの全幅表示にして画面外にはみ出さない */
  'max-[480px]:left-3 max-[480px]:right-3 max-[480px]:min-w-0 max-[480px]:max-w-none';

const TOAST_TYPE: Record<ToastProps['type'], string> = {
  success: 'bg-emerald-500 text-white', // #10B981
  error: 'bg-red-500 text-white', // #EF4444
  info: 'bg-blue-500 text-white', // #3B82F6
};

const ICON_WRAPPER = 'flex items-center justify-center shrink-0';

const MESSAGE = 'text-[0.9375rem] font-medium leading-[1.5]';

const Toast: React.FC<ToastProps> = ({
  message,
  type,
  duration = 3000,
  onClose,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearTimeout(timer);
    };
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-5 h-5" />;
      case 'error':
        return <XCircle className="w-5 h-5" />;
      case 'info':
        return <Info className="w-5 h-5" />;
      default:
        return null;
    }
  };

  return (
    <div className={`${TOAST_CONTAINER} ${TOAST_TYPE[type] ?? ''}`}>
      <div className={ICON_WRAPPER}>
        {getIcon()}
      </div>
      <span className={MESSAGE}>{message}</span>
    </div>
  );
};

export default Toast;
